const COUNTRY_TO_CURRENCY: Record<string, string> = {
  // ── South Asia ──────────────────────────────────────────────
  IN: 'INR', PK: 'PKR', BD: 'BDT', LK: 'LKR', NP: 'NPR',
  BT: 'BTN', MV: 'MVR', AF: 'AFN',

  // ── Middle East ─────────────────────────────────────────────
  AE: 'AED', SA: 'SAR', QA: 'QAR', KW: 'KWD', BH: 'BHD',
  OM: 'OMR', JO: 'JOD', LB: 'LBP', SY: 'SYP', IQ: 'IQD',
  IR: 'IRR', YE: 'YER', IL: 'ILS', PS: 'ILS',

  // ── North America ───────────────────────────────────────────
  US: 'USD', CA: 'CAD', MX: 'MXN', GT: 'GTQ', BZ: 'BZD',
  HN: 'HNL', SV: 'USD', NI: 'NIO', CR: 'CRC', PA: 'PAB',
  CU: 'CUP', DO: 'DOP', HT: 'HTG', JM: 'JMD', TT: 'TTD',
  BB: 'BBD', LC: 'XCD', VC: 'XCD', GD: 'XCD', AG: 'XCD',
  DM: 'XCD', KN: 'XCD', BS: 'BSD', KY: 'KYD', BM: 'BMD',
  AW: 'AWG', CW: 'ANG', SX: 'ANG', TC: 'USD', VG: 'USD',
  VI: 'USD', PR: 'USD', MP: 'USD', AS: 'USD',

  // ── South America ───────────────────────────────────────────
  BR: 'BRL', AR: 'ARS', CL: 'CLP', CO: 'COP', PE: 'PEN',
  BO: 'BOB', PY: 'PYG', UY: 'UYU', VE: 'VES', GY: 'GYD',
  SR: 'SRD', FK: 'FKP', EC: 'USD', GF: 'EUR', GP: 'EUR',
  MQ: 'EUR',

  // ── Europe ──────────────────────────────────────────────────
  DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', PT: 'EUR',
  NL: 'EUR', BE: 'EUR', AT: 'EUR', IE: 'EUR', FI: 'EUR',
  GR: 'EUR', LU: 'EUR', SK: 'EUR', SI: 'EUR', EE: 'EUR',
  LV: 'EUR', LT: 'EUR', CY: 'EUR', MT: 'EUR', MC: 'EUR',
  AD: 'EUR', SM: 'EUR', VA: 'EUR', ME: 'EUR', XK: 'EUR',
  GB: 'GBP', CH: 'CHF', LI: 'CHF', NO: 'NOK', SE: 'SEK',
  DK: 'DKK', IS: 'ISK', PL: 'PLN', CZ: 'CZK', HU: 'HUF',
  RO: 'RON', BG: 'BGN', HR: 'EUR', RS: 'RSD', BA: 'BAM',
  MK: 'MKD', AL: 'ALL', MD: 'MDL', UA: 'UAH', BY: 'BYN',
  RU: 'RUB', GE: 'GEL', AM: 'AMD', AZ: 'AZN', TR: 'TRY',
  GI: 'GIP', IM: 'GBP', JE: 'GBP', GG: 'GBP',

  // ── East Asia ───────────────────────────────────────────────
  CN: 'CNY', JP: 'JPY', KR: 'KRW', KP: 'KPW', HK: 'HKD',
  MO: 'MOP', TW: 'TWD', MN: 'MNT',

  // ── Southeast Asia ──────────────────────────────────────────
  SG: 'SGD', MY: 'MYR', ID: 'IDR', PH: 'PHP', TH: 'THB',
  VN: 'VND', KH: 'KHR', LA: 'LAK', MM: 'MMK', BN: 'BND',
  TL: 'USD',

  // ── Central Asia ────────────────────────────────────────────
  KZ: 'KZT', UZ: 'UZS', TJ: 'TJS', KG: 'KGS', TM: 'TMT',

  // ── Oceania ─────────────────────────────────────────────────
  AU: 'AUD', NZ: 'NZD', FJ: 'FJD', PG: 'PGK', SB: 'SBD',
  VU: 'VUV', WS: 'WST', TO: 'TOP', KI: 'AUD', NR: 'AUD',
  TV: 'AUD', CK: 'NZD', NU: 'NZD', PF: 'XPF', NC: 'XPF',
  WF: 'XPF', GU: 'USD', PW: 'USD', FM: 'USD', MH: 'USD',

  // ── North & East Africa ─────────────────────────────────────
  EG: 'EGP', SD: 'SDG', SS: 'SSP', ET: 'ETB', ER: 'ERN',
  DJ: 'DJF', SO: 'SOS', KE: 'KES', UG: 'UGX', TZ: 'TZS',
  RW: 'RWF', BI: 'BIF', MW: 'MWK', ZM: 'ZMW', ZW: 'ZWL',
  MZ: 'MZN',

  // ── West Africa ─────────────────────────────────────────────
  NG: 'NGN', GH: 'GHS', SN: 'XOF', CI: 'XOF', ML: 'XOF',
  BF: 'XOF', NE: 'XOF', TG: 'XOF', BJ: 'XOF', GW: 'XOF',
  CM: 'XAF', CF: 'XAF', TD: 'XAF', CG: 'XAF', GA: 'XAF',
  GQ: 'XAF', GM: 'GMD', GN: 'GNF', SL: 'SLL', LR: 'LRD',
  CV: 'CVE', ST: 'STN', MR: 'MRU',

  // ── Central Africa ──────────────────────────────────────────
  CD: 'CDF', AO: 'AOA',

  // ── Southern Africa ─────────────────────────────────────────
  ZA: 'ZAR', NA: 'NAD', BW: 'BWP', LS: 'LSL', SZ: 'SZL',

  // ── North Africa / Maghreb ──────────────────────────────────
  MA: 'MAD', DZ: 'DZD', TN: 'TND', LY: 'LYD',

  // ── Indian Ocean ────────────────────────────────────────────
  MU: 'MUR', SC: 'SCR', KM: 'KMF', MG: 'MGA', RE: 'EUR',
  YT: 'EUR',

  // ── Territories & Special Cases ─────────────────────────────
  AI: 'XCD', AQ: 'USD', IO: 'USD', CX: 'AUD', CC: 'AUD',
  FO: 'DKK', GL: 'DKK', MS: 'XCD', NF: 'AUD', PN: 'NZD',
  BL: 'EUR', SH: 'SHP', MF: 'EUR', PM: 'EUR', SJ: 'NOK',
  TK: 'NZD', EH: 'MAD',
};

export function getCountryCurrency(countryCode: string): string {
  return COUNTRY_TO_CURRENCY[countryCode?.toUpperCase()] ?? 'USD';
}

export default COUNTRY_TO_CURRENCY;
